import { fillVisibleScreenClass } from './keyboardAwareClasses';

/**
 * DialogContent classes for a dialog that takes the whole screen on a phone (a form, a picker,
 * the customer's invoice review). Pinned to the top-left rather than centred, so it doesn't sit
 * a few pixels down when the browser's toolbar collapses. Add the layout (flex column, padding,
 * scroll) at the call site, and give the dialog a worded Close or Cancel instead of the corner X.
 *
 * It fills the part of the screen the on-screen keyboard leaves visible, so its scrolling body
 * and any bar at its bottom end at the top of the keyboard. Pass
 * `keepFocusVisibleAboveKeyboard={false}` to DialogContent with it: that option re-centres the
 * dialog when the keyboard opens, which pulls a full-screen surface down off the top.
 */
export const phoneFullScreenDialogClass =
  `bg-card left-0 ${fillVisibleScreenClass} w-screen max-w-none translate-x-0 translate-y-0 rounded-none border-0 sm:rounded-none ` +
  // Rise up from the bottom of the screen like a sheet, instead of the centred dialog's zoom,
  // which from the top-left corner looks like it flies in from there.
  'data-[state=open]:!slide-in-from-left-0 data-[state=open]:!slide-in-from-bottom-8 data-[state=open]:!zoom-in-100 ' +
  'data-[state=closed]:!slide-out-to-left-0 data-[state=closed]:!slide-out-to-bottom-8 data-[state=closed]:!zoom-out-100';
